import type { ButtonSize, ButtonVariant } from './types'

/**
 * Высоты кнопки по variant/size — спека 01 §4.
 * В токенах есть только $control-height-s/m/l/xl (44/50/52/60), поэтому size
 * подбирает ближайший токен внутри диапазона своего variant'а, без придуманных px.
 */
export const BUTTON_HEIGHT: Record<ButtonVariant, Record<ButtonSize, string>> = {
  PRIMARY: {
    S: 'var(--control-height-s)',
    M: 'var(--control-height-l)',
    L: 'var(--control-height-xl)',
  },
  SECONDARY: {
    S: 'var(--control-height-s)',
    M: 'var(--control-height-m)',
    L: 'var(--control-height-l)',
  },
  GHOST: {
    S: 'var(--control-height-s)',
    M: 'var(--control-height-s)',
    L: 'var(--control-height-m)',
  },
  DESTRUCTIVE: {
    S: 'var(--control-height-s)',
    M: 'var(--control-height-m)',
    L: 'var(--control-height-m)',
  },
}

/** Размер иконки в кнопке и диаметр спиннера — фиксированы вне зависимости от size. */
export const BUTTON_ICON_SIZE = 18
export const BUTTON_SPINNER_SIZE = 16
